module.exports = __webpack_public_path__ + "img/toggle-on.b6602edb.svg";